import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PdfExportState } from './pdf-export.reducer';

export const featureName = 'pdfExport';
export const selectPdfExportState = createFeatureSelector<PdfExportState>(featureName);

export const selectPdfExportStatus = createSelector(selectPdfExportState, (state) => state.state);
export const selectPdfExportError = createSelector(selectPdfExportState, (state) => state.error);
export const selectPdfExportLink = createSelector(selectPdfExportState, (state) => state.downloadLink);
